import { layout } from 'app_previous/styles/layout';
import styled, { css } from 'styled-components';

interface ArticleBodyWithTableOfContentsContainerProps {
  hasTableOfContents?: boolean;
}

export const ArticleBodyWithTableOfContentsContainer = styled.div<ArticleBodyWithTableOfContentsContainerProps>`
  margin: 2rem auto 0px;
  position: relative;
  z-index: 1;
  max-width: 1180px;
  padding: 0rem 1.5rem;

  ${({ hasTableOfContents }) =>
    !hasTableOfContents
      ? ''
      : css`
          display: grid;
          grid-template-columns: 360px 1fr;
          grid-column-gap: 5rem;

          @media all and (max-width: ${layout.lg}) {
            grid-template-columns: 320px 1fr;
          }

          @media all and (max-width: ${layout.md}) {
            grid-template-columns: 1fr;

            .fixed-table-of-contents-container.sticky-toc {
              display: none;
            }
          }
        `}

  @media all and (max-width: ${layout.subLg}) {
    padding: 0rem 2rem;
  }
  @media all and (max-width: ${layout.xs}) {
    padding: 0rem 1rem;
  }
`;
